import React from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'utils/navigation'
import { SortableTable, PercentMeter, Button, ExpandableList, Popup } from 'components/UIElements'
import { SITES_MESSAGES } from '../../../../Instruments/utils/instrumentConstants'
import generateLocalesMap, { formatLangCode } from 'utils/locales'
import '../stylesheets/announcements.scss'
import EditSites from '../../../../Instruments/routes/InstrumentsPage/components/EditPromotionSites'
import UploadTranslationInput from '../../../../Instruments/routes/InstrumentsPage/components/UploadTranslationInput'

class AnnouncementsPage extends React.Component {
  constructor(props) {
    super(props)
    const { currentCommunicationType } = this.props
    this.state = {
      selectedFilter: 'outbox',
      selectedSMSFilter: 'outbox',
      selectedPage: currentCommunicationType,
      toolTipX: null,
      toolTipY: null,
      languageMap: {},
      checked: {},
    }
    this.filters = {
      outbox: this.outboxFilter.bind(this),
      draft: this.draftFilter.bind(this),
    }
    this.renderFunctions = {
      readStatus: this.renderReadStatus.bind(this),
      title: this.renderTitle.bind(this),
      recipients: this.renderRecipients.bind(this),
      action: this.renderAction.bind(this),
    }
  }

  componentDidMount() {
    const { locales } = this.props
    if (locales) {
      this.setState({ languageMap: generateLocalesMap(locales) })
    }
  }

  onSelectFilter = (selectedFilter, isAnnouncements = true) => {
    if (isAnnouncements) {
      this.setState({ selectedFilter })
    } else {
      this.setState({ selectedSMSFilter: selectedFilter })
    }
  }

  onSelectPage = selectedPage => {
    const { setCommunicationType } = this.props
    setCommunicationType(selectedPage)
    this.setState({ selectedPage })
  }

  _isSelected = (filterName, isAnnouncements = true) => {
    const { selectedFilter, selectedSMSFilter } = this.state
    if (isAnnouncements) return selectedFilter === filterName
    return selectedSMSFilter === filterName
  }

  _isSelectedPage = filterName => {
    const { selectedPage } = this.state
    return selectedPage === filterName
  }

  onDelete = id => {
    const { deleteAnnouncement, params } = this.props
    const { studyID } = params
    const { checked } = this.state

    const clearChecked = () => {
      this.setState(prev => {
        const prevState = {
          ...prev,
          deleting: { ...checked },
        }
        if (!prevState.deleting[id]) prevState.deleting[id] = true
        return prevState
      })
    }
    return e => {
      e.stopPropagation()
      deleteAnnouncement(studyID, id || Object.keys(checked), clearChecked, () => {
        this.onUpdateChecked({})
        this.onUpdateDeleting({})
      })
    }
  }

  onUpdateChecked = checked => {
    this.setState({ checked })
  }

  onUpdateDeleting = deleting => {
    this.setState({ deleting })
  }

  outboxFilter = props => {
    return props?.deployed
  }

  renderReadStatus = rowProps => {
    return (
      <td key='read-percent-cell'>
        <PercentMeter ratio={rowProps.value} />
      </td>
    )
  }

  renderTitle = (rowProps, idx) => {
    const { isAnnouncement, translations, otherLanguages } = rowProps
    const { languageMap, toolTipX, toolTipY } = this.state
    let langArr = ['en_US']
    if (otherLanguages) langArr = [...langArr, ...otherLanguages.map(formatLangCode)]
    if (translations) langArr = Object.keys(translations)

    const languageTags = langArr.map(languageId => {
      return (
        <React.Fragment key={`${languageId}-announcement-tag`}>
          <div className='tag' onMouseMove={e => this.setState({ toolTipX: e.clientX, toolTipY: e.clientY })}>
            {languageId.toUpperCase()}
          </div>
          <div
            className='language-name-tooltip'
            style={{
              top: `${toolTipY + 10}px`,
              left: `${toolTipX + 10}px`,
            }}>
            {languageMap[languageId] ?? languageId}
          </div>
        </React.Fragment>
      )
    })

    return (
      <td className='title-column' key={`row_${idx}`}>
        <div className='flexed start-justified start-aligned'>
          <div>
            <div className='name'>{rowProps.value}</div>
            {isAnnouncement && <div className='languages flexed start-justified'>{languageTags}</div>}
          </div>
        </div>
      </td>
    )
  }

  renderRecipients = ({ value, idx }) => (
    <td key={`row-${idx}`}>
      {value.map((item, index) => {
        if (!item?.label) {
          const hasMissingSites = item.includes(SITES_MESSAGES.MISSING_SITES)
          return (
            <div className={`recipients ${hasMissingSites ? 'missed' : ''}`} key={item.label || index}>
              {item}
            </div>
          )
        }
        return <ExpandableList className='recipients' key={index.toString()} {...item} />
      })}
    </td>
  )

  onRowClick = rowData => {
    const { selectedPage } = this.state
    const isAnnouncements = selectedPage === 'announcements'
    const { params } = this.props
    const { studyID, studyVersionID } = params
    const announcementID = rowData[0].id
    browserHistory.push(
      `/studies/${studyID}/${studyVersionID}/communication/${isAnnouncements ? 'announcement' : 'sms'
      }/${announcementID}`,
    )
  }

  rowCanClick = rowData => {
    if (this.props.isReadOnlyState) return !this.props.isReadOnlyState
    const announcementID = rowData[0].id
    return !!announcementID
  }

  draftFilter = props => {
    return !props.deployed
  }

  onEditStudyPromotionConfig(id, checkedSites = []) {
    return e => {
      e.stopPropagation()
      const {
        allAnnouncements,
        openModal,
        closeModal,
        disabled,
        leafSites,
        resetPromotionSites,
        saveInstrumentSitesForPromotion,
        setPromotionSites,
        siteSelectionList,
        studyID,
      } = this.props
      const currentAnnouncement = allAnnouncements.filter(item => item.id === id)[0]
      openModal({
        children: (
          <EditSites
            closeModal={closeModal}
            checkedSites={checkedSites}
            disabled={disabled}
            instrument={currentAnnouncement}
            isAnnouncement
            leafSites={leafSites}
            setPromotionSites={setPromotionSites}
            siteSelectionList={siteSelectionList}
            saveInstrumentSitesForPromotion={saveInstrumentSitesForPromotion}
            studyID={studyID}
          />
        ),
        className: 'edit-sites-modal',
        closeOnBackgroundClick: true,
        noButtons: true,
        onCancel: () => {
          resetPromotionSites()
          closeModal()
        },
      })
    }
  }

  renderAction({ id, siteList, type, title, envConfigSites }) {
    const {
      studyLock,
      isReadOnlyState,
      params,
      isAllowedToEditAnnouncements,
      hasStudyPromotion,
      currentVersionStatus,
    } = this.props
    const { studyID, studyVersionID } = params
    const { selectedPage } = this.state
    const isAnnouncements = selectedPage === 'announcements'
    return (
      <td className='action-cell' key={`row_${id}`}>
        <div className='flexed start-justified'>
          <Popup
            dark
            position='left'
            className={`download${studyLock ? ' locked' : ''}`}
            trigger={<Button link icon='fas fa-cloud-download-alt' />}>
            <Button
              link
              onClick={this.onDownloadJSONs(id, title, type)}
              content={`Download Announcement JSON`}
            />
            {hasStudyPromotion && (
              <Button
                link
                content='CSV Translation Template'
                onClick={() =>
                  this.onDownloadTranslations({
                    [id]: {
                      type,
                      title,
                    },
                  })
                }
              />
            )}
          </Popup>
          {((isAllowedToEditAnnouncements && !isReadOnlyState) || (siteList && siteList.length)) && !studyLock ? (
            <Popup
              dark
              position='left'
              className='edit'
              trigger={<Button link id='edit-announcement' icon='fas fa-pencil-alt' />}>
              {isAllowedToEditAnnouncements && !isReadOnlyState && (
                <Button
                  link
                  onClick={() => {
                    browserHistory.push(
                      `/studies/${studyID}/${studyVersionID}/communication/${isAnnouncements ? 'announcement' : 'sms'
                      }/${id}`,
                    )
                  }}
                  content={`Edit Announcement`}
                />
              )}

              {hasStudyPromotion && siteList && !!siteList.length && (
                <Button
                  link
                  onClick={this.onEditStudyPromotionConfig(id, envConfigSites[currentVersionStatus])}
                  content='Edit Sites'
                />
              )}
            </Popup>
          ) : null}
          {!studyLock && !isReadOnlyState && (
            <Button
              id='trash-icon'
              className='fit-content-width-button'
              onClick={this.onDelete(id)}
              link
              icon='fas fa-trash'
            />
          )}
        </div>
      </td>
    )
  }

  onDownloadTranslations = translation => {
    const { downloadTranslations, studyID } = this.props
    let { checked } = this.state
    checked = Object.keys(checked).length ? checked : translation
    downloadTranslations(studyID, checked)
  }

  onDownloadJSONs = (id, title, type) => {
    const { downloadInstrument, studyID } = this.props
    const { checked: _checked } = this.state
    return e => {
      const checked = id === undefined ? _checked : { [id]: { title, type } }
      e.stopPropagation()
      downloadInstrument(studyID, checked)
    }
  }

  onOpenUploadModal = () => {
    const { allAnnouncements, closeModal, openModal, studyID, uploadTranslation } = this.props
    const { checked } = this.state
    const instrument = {}
    instrument.id = Object.keys(checked)[0]
    Object.assign(instrument, allAnnouncements.filter(item => item.id === instrument.id)[0])

    openModal({
      noButtons: true,
      closeOnBackgroundClick: true,
      children: (
        <UploadTranslationInput
          closeModal={closeModal}
          studyID={studyID}
          uploadTranslation={uploadTranslation}
          instrument={instrument}
        />
      ),
    })
  }

  renderPage = (isAnnouncements = false) => {
    const {
      announcementsList,
      currentVersionStatus,
      smsList,
      params,
      studyLock,
      isReadOnlyState,
      hasStudyPromotion,
    } = this.props
    const { studyID, studyVersionID } = params
    const { selectedFilter, selectedSMSFilter } = this.state
    const { checked, deleting } = this.state
    const ids = Object.keys(checked)
    let headerOptions = [
      { key: 'title', sortable: true, component: isAnnouncements ? 'Subject' : 'Label' },
      { key: 'recipients', sortable: false, component: 'Recipients' },
      { key: 'lastEdited', sortable: true, component: 'Last Edited' },
      { key: 'scheduled', sortable: true, component: 'Date Scheduled' },
      { key: 'readStatus', sortable: true, component: 'Read Status' },
      { key: 'action', component: 'Action' },
    ]

    const currentSelectedFilter = isAnnouncements ? selectedFilter : selectedSMSFilter

    if (selectedFilter === 'draft' || !isAnnouncements) {
      headerOptions = headerOptions.slice(0, headerOptions.length - 1)
    }

    const rowHighlightOptions = hasStudyPromotion
      ? [
        {
          hasHighlightClassName: row => {
            let isHighlited = false
            const { siteList, envConfigSites } = row.find(item => item.key === 'action') || {}
            const versionStatusLower = currentVersionStatus.toLowerCase()
            switch (versionStatusLower) {
              case 'uat':
              case 'live':
                // validate if env_config[currentVersionStatus] has sites
                // if not higlithed is on
                isHighlited = !envConfigSites[currentVersionStatus] || !envConfigSites[currentVersionStatus]?.length
                break
              default:
                break
            }
            return siteList && siteList.length > 0 && isHighlited
          },
          highlightClassName: 'highlighted site-edition',
        },
      ]
      : []

    return (
      <div>
        {!isReadOnlyState ? (
          <div className='flexed-header end-justified'>
            <div />

            {!studyLock && !isReadOnlyState && !!ids?.length && (
              <Button key='delete' grey id='delete-instrument' content='Delete' onClick={this.onDelete()} />
            )}
            {hasStudyPromotion && ids.length === 1 && !studyLock && (
              <Button
                key='upload'
                grey
                id='upload-csv-translation'
                content='Upload CSV with Translation'
                onClick={this.onOpenUploadModal}
              />
            )}
            <Button
              disabled={studyLock}
              id={isAnnouncements ? 'create-announcement' : 'new-message'}
              content={isAnnouncements ? 'Create Announcement' : 'New Message'}
              onClick={() =>
                !studyLock &&
                browserHistory.push(
                  `/studies/${studyID}/${studyVersionID}/communication/create${isAnnouncements ? 'announcement' : 'sms'
                  }`,
                )
              }
            />
          </div>
        ) : (
          <div className='flexed-header end-justified'>
            {hasStudyPromotion && ids.length === 1 && !studyLock && (
              <Button
                key='upload'
                grey
                id='upload-csv-translation'
                content='Upload CSV with Translation'
                onClick={this.onOpenUploadModal}
              />
            )}
          </div>
        )}

        {!hasStudyPromotion ? (
          <div className='selected-button-list sub'>
            <Button
              id='outbox-tab'
              selected={this._isSelected('outbox', isAnnouncements)}
              onClick={() => {
                this.onSelectFilter('outbox', isAnnouncements)
              }}
              content='Outbox'
            />
            <Button
              id='draft-tab'
              selected={this._isSelected('draft', isAnnouncements)}
              onClick={() => {
                this.onSelectFilter('draft', isAnnouncements)
              }}
              content='Drafts'
            />
          </div>
        ) : null}

        <SortableTable
          id={isAnnouncements ? 'announcement-table' : 'sms-table'}
          emptyText={currentSelectedFilter === 'outbox' ? 'Your outbox is empty.' : 'You have no outstanding drafts.'}
          onRowClick={isReadOnlyState ? null : this.onRowClick}
          rowCanClick={this.rowCanClick}
          filters={{ scheduled: this.filters[currentSelectedFilter] }}
          sortingBy='lastEdited'
          initialOrder='descending'
          renderFunctions={this.renderFunctions}
          headerOptions={headerOptions}
          rowList={isAnnouncements ? announcementsList : smsList}
          onUpdateChecked={this.onUpdateChecked}
          checked={studyLock ? null : checked}
          rowHighlightOptions={rowHighlightOptions}
          deleting={deleting}
        />
      </div>
    )
  }

  render() {
    const { selectedPage } = this.state
    const { communication, isClinro } = this.props
    const isSmsDisabled = communication?.sms[isClinro ? 'clinro' : 'admin'].enabled ?? true

    const isAnnouncements = selectedPage === 'announcements'

    return (
      <div className='announcements page'>
        <div className='selected-button-list '>
          <Button
            id='announcements-tab'
            selected={this._isSelectedPage('announcements')}
            onClick={() => {
              this.onSelectPage('announcements')
            }}
            content='Announcements'
          />
          {isSmsDisabled && (
            <Button
              id='sms-tab'
              selected={this._isSelectedPage('sms')}
              onClick={() => {
                this.onSelectPage('sms')
              }}
              content='SMS'
            />
          )}
        </div>
        {isAnnouncements ? this.renderPage(isAnnouncements) : this.renderPage()}
      </div>
    )
  }
}

AnnouncementsPage.propTypes = {
  announcementsList: PropTypes.arrayOf(PropTypes.array),
  currentCommunicationType: PropTypes.string,
  locales: PropTypes.arrayOf(PropTypes.object),
  params: PropTypes.shape({
    studyID: PropTypes.string,
  }),
  studyLock: PropTypes.bool,
  setCommunicationType: PropTypes.func,
  smsList: PropTypes.arrayOf(PropTypes.array),
}

export default AnnouncementsPage
